// px
import { useNuxtApp } from '#imports'
export const HEADER_HEIGHT = 61 // px
export const MOBILE_HEADER_HEIGHT = 61 // px
export const MOBILE_HEADER_TOPICS_HEIGHT = 0

export function useLayout() {
  const route = useRoute()

  const routesToExpand = [
    'index',
    'topic-id',
    'username',
    'visual',
  ]

  const isHeaderExpanded = computed(() => routesToExpand.includes(route.name as string || ''))
  const mobileHeaderHeight = computed(() => `${isHeaderExpanded.value ? MOBILE_HEADER_HEIGHT + MOBILE_HEADER_TOPICS_HEIGHT : MOBILE_HEADER_HEIGHT}px`)

  return {
    isHeaderExpanded,
    mobileHeaderHeight,
  }
}

export const menuItems = [
  'promptLibrary',
  'desktopApp',
  'theDailyBite',
  'plugins',
] as const
export type MenuItem = typeof menuItems[number]

export const useHeaderMenusActive = () => {
  const nuxtApp = useNuxtApp()
  if (!nuxtApp)
    throw new Error('Nuxt não está disponível ainda!')

  return useState<Record<MenuItem, boolean>>('header-menus', () => ({
    promptLibrary: false,
    desktopApp: false,
    theDailyBite: false,
    plugins: false,
  }))
}

export function closeAllHeaderMenus() {
  const openMenuState = useHeaderMenusActive()

  menuItems.forEach((item) => {
    openMenuState.value[item] = false
  })
}

export function openHeaderMenu(item: MenuItem) {
  const openMenuState = useHeaderMenusActive()

  closeAllHeaderMenus()
  openMenuState.value[item] = true
}

export function toggleHeaderMenu(item: MenuItem) {
  const openMenuState = useHeaderMenusActive()

  const oldValue = openMenuState.value[item]
  closeAllHeaderMenus()
  openMenuState.value[item] = !oldValue
}
